import React, { forwardRef } from "react";
import { Menu, MenuItem, SubMenu } from "@szhsin/react-menu";
import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/slide.css";

import {
  Dashboard,
  FavoritesIcon as Favorites,
  Clients,
  Activity,
  Attendance,
  Revenue,
  Custom,
  Other
} from "../../../assets/images/svg";

import "./Navigation.scss";

const images = {
  Favorites,
  Clients,
  Activity,
  Attendance,
  Revenue,
  Custom,
  Other
};

const Navigation = ({ menu, activeNavItem, selectedMenuItem }) => {
  return (
    <nav id="nav-menu">
      {menu.map((item) => {
        const { itemName, menu = "" } = item;
        return (
          <Menu
            menuButton={<NavItem item={item} activeNavItem={activeNavItem} />}
            transition
            key={itemName}
            menuClassName="menu"
          >
            {menu && renderMenu(menu, selectedMenuItem, itemName)}
          </Menu>
        );
      })}
    </nav>
  );
};

// eslint-disable-next-line react/display-name
const NavItem = forwardRef(({ item, activeNavItem, onClick, onKeyDown }, ref) => {
  const getImage = (key) => {
    let SvgComponent = images[key];
    return SvgComponent ? <SvgComponent /> : null;
  };
  const { itemName, itemLink, menu } = item;

  const hasMenu = !!menu;
  const lowerCasedItemName = itemName.toLowerCase();
  return hasMenu ? (
    <div
      id={lowerCasedItemName}
      className={`react-nav__item ${
        itemName === activeNavItem ? "active " : ""
      }${lowerCasedItemName}`}
      tabIndex={0}
      ref={ref}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      <div className="icon">{getImage(itemName)}</div>

      <div className="title">{itemName}</div>
    </div>
  ) : (
    <div
      id="dashboard"
      className={`react-nav__item ${itemName === activeNavItem ? "active " : ""}dashboard`}
    >
      <a href={itemLink} className="link">
        <div className="icon">
          <Dashboard />
        </div>

        {itemName}
      </a>
    </div>
  );
});

const renderMenu = (menu, selectedMenuItem, itemName) => {
  if (menu && menu.length === 0) {
    return (
      <MenuItem key={itemName}>
        {itemName === "Favorites" ? "No selected Favorites" : "No available reports"}
      </MenuItem>
    );
  }

  return menu.map((item) => {
    let lowerCasedItemName = item.itemName.toLowerCase();
    // for qa testing
    lowerCasedItemName === "new client conversion funnel"
      ? (lowerCasedItemName = "laser")
      : lowerCasedItemName;

    if (!item.menu) {
      return (
        <MenuItem
          id={lowerCasedItemName}
          className={item.itemName === selectedMenuItem ? "selected" : ""}
          href={item.itemLink}
          value={item.itemName}
          key={item.itemName}
        >
          {item.itemName}
        </MenuItem>
      );
    }

    return (
      <SubMenu label={item.itemName} key={item.itemName} menuClassName="subMenu">
        {renderMenu(item.menu, selectedMenuItem)}
      </SubMenu>
    );
  });
};

export default Navigation;
